module.exports = __webpack_public_path__ + "media/images/icons/volume-off-629fce8f8ec55ca128eb97f34babc666.svg";